module.exports = "/_next/static/images/forbes-685a98b8a7a9ac7fe016bac11fa72e7d.png";